import React, { useState } from "react";
import Building_Burz from "../../assets/images/building_burz.png";
import { Link } from "react-router-dom";
import DeleteModal from "../edu-helper/delete-modal";
import axios from "axios";
import { toast, Bounce } from "react-toastify";
import { baseUrl } from "../../config/baseUrl";

export const JobScheduleCard = ({
  report_done,
  id,
  cleaning_type,
  assign_date,
  college,
  company,
  campus,
  setActivateJobScheduleEdit,
  setSelectJobScheduleRow,
  setForceUpdate,
  forceUpdate,
}) => {
  let deleteHandle = async (id) => {
    let response;
    try {
      response = await axios(`${baseUrl}/delete_scheduler/${id}/`, {
        method: "DELETE",
        headers: {
          Authorization: "Token " + localStorage.getItem("token"),
        },
      });
      if (response?.status === 200) {
        setForceUpdate(!forceUpdate);
        toast.success("Edit College Successfully", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
      }
    } catch (error) {
      toast.error(error.response.data.message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    }
  };

  return (
    <div className="col-lg-3 col-md-6 col-sm-6">
      <div className="job-shch-card">
        <div className="job-shch-card-img">
          <img src={Building_Burz} alt="" />
        </div>
        <div className="job-shch-card-cntnt">
          <p className="date">
            <i className="fa fa-calendar-alt me-1" />
            {assign_date}
          </p>
          <h5>{company[0]?.name}</h5>
          <p className="assigned">
            Block:<span>{college?.block_name}</span>
          </p>
          <p className="assigned">
            College:
            <span>
              {campus?.filter((k) => k?.id === college?.campus)[0]?.campus_name}
            </span>
          </p>
        </div>
        <div className="job-shch-card-bttm">
          <Link to="#" className="thm-btn">
            {cleaning_type}
          </Link>
          <div className="dropdown cstm-menu ">
            <button
              type="button"
              id="jobmenu"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              className={
                cleaning_type === "REGULAR_CLEANING"
                  ? "bg-success text-white"
                  : "bg-danger"
              }
            >
              <i className="fa fa-list" />
            </button>
            <ul className="dropdown-menu" aria-labelledby="jobmenu">
              <li>
                <Link
                  className="dropdown-item"
                  role="button"
                  //   className="btn btn-outline-warning"
                  data-bs-toggle="modal"
                  data-bs-target="#editjobschedule"
                  onClick={() => {
                    setActivateJobScheduleEdit(true);
                    setSelectJobScheduleRow({
                      report_done,
                      id,
                      cleaning_type,
                      assign_date,
                      college,
                      company,
                      campus,
                    });
                  }}
                >
                  Edit
                </Link>
              </li>
              <li>
                <Link
                  onClick={() => {}}
                  className="dropdown-item"
                  role="button"
                  //   className="btn btn-outline-warning"
                  data-bs-toggle="modal"
                  data-bs-target="#deletemodal"
                >
                  Delete
                </Link>
              </li>
            </ul>
          </div>
          {report_done ? (
            <span className="status complete">Complete</span>
          ) : (
            <span className="status pending">Pending</span>
          )}
        </div>
      </div>
      <DeleteModal deleteHandle={deleteHandle} id={id} />
    </div>
  );
};
